/**
 * AvatarDisplay Barrel Export
 */

export { AvatarDisplay } from './AvatarDisplay';
export type { AvatarDisplayProps } from './AvatarDisplay';

